import { render, staticRenderFns } from "./couchDetails.vue?vue&type=template&id=2fd80c5c&"
import script from "./couchDetails.vue?vue&type=script&lang=js&"
export * from "./couchDetails.vue?vue&type=script&lang=js&"
import style0 from "./couchDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports